import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row research-items-container" }
const _hoisted_2 = { class: "edits-section-details-p" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "source-data" }
const _hoisted_5 = {
  key: 0,
  class: "edits-section-details-container"
}
const _hoisted_6 = { class: "edits-section-details-icon" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "edits-section-details-trigger-text" }, "Details", -1)
const _hoisted_10 = { class: "edits-section-details-trigger-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (!_ctx.items || _ctx.items.length == 0)
    ? (_openBlock(), _createBlock(_component_q_expansion_item, {
        key: 0,
        class: "edits-section-title",
        label: _ctx.sectionName,
        disable: true
      }, null, 8, ["label"]))
    : (_openBlock(), _createBlock(_component_q_expansion_item, {
        key: 1,
        class: "edits-section-title io-mfe-ig-expansion-item",
        label: _ctx.sectionName,
        "default-opened": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_q_list, { dense: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                  return (_openBlock(), _createBlock(_component_q_item, { key: item }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        class: _normalizeClass(["edit-flag", item.level == 'Critical' ? 'critical' : 'warning']),
                        name: "fa-solid fa-flag-pennant",
                        size: "16px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_tooltip, { "max-width": "300px" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.hoverText(item.level)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["class"]),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_2, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.editsContent(item.description),
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editsClick && _ctx.editsClick(...args)))
                          }, null, 8, _hoisted_3),
                          _createElementVNode("span", _hoisted_4, _toDisplayString(item.source_data), 1)
                        ]),
                        (item.detailTrigger)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_q_icon, { name: "fa-light fa-info-circle" })
                              ]),
                              _createElementVNode("span", {
                                class: "edits-section-details-content",
                                innerHTML: _ctx.removeBRTags(item.details),
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editsClick && _ctx.editsClick(...args)))
                              }, null, 8, _hoisted_7)
                            ]))
                          : _createCommentVNode("", true),
                        (item.details)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "edits-section-details-trigger",
                              onClick: () => item.detailTrigger = !item.detailTrigger
                            }, [
                              _hoisted_9,
                              _createElementVNode("span", _hoisted_10, [
                                (item.detailTrigger)
                                  ? (_openBlock(), _createBlock(_component_q_icon, {
                                      key: 0,
                                      class: "edits-section-details-trigger-icon",
                                      name: "fa-light fa-angle-up"
                                    }))
                                  : (_openBlock(), _createBlock(_component_q_icon, {
                                      key: 1,
                                      class: "edits-section-details-trigger-icon",
                                      name: "fa-light fa-angle-down"
                                    }))
                              ])
                            ], 8, _hoisted_8))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["label"]))
}